export default {
  setDetails({ commit }, details) {
    commit("SET_DETAILS", details);
  },
};
